import React from "react";
import styled from "styled-components";
import { FontWeight, content, useTheme } from "@glossy";
import SafeHTML from "@ui-kit/safe-html";

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div<{ isPage?: boolean; size?: "s" | "m" }>`
  margin-top: 24px;
  font-size: ${(props) => (props.size === "s" ? "14px" : "18px")};
  font-weight: ${(props) =>
    props.size === "s" ? FontWeight.Normal : FontWeight.Bold};
  color: ${(props) => content(props, props.isPage ? "primary" : "secondary")};
  text-align: center;
`;

interface IProps {
  message: string;
  isPage?: boolean;
  size?: "s" | "m";
  className?: string;
}

const UiKitEmpty = ({ message, isPage, size = "m", className }: IProps) => {
  const theme = useTheme();

  return (
    <Root className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 256"
        height="126px"
        width="126px"
      >
        <path
          fill={content({ theme }, "secondary")}
          d="M128.85 0a82.67 82.67 0 00-82.7 82.64V205.1l2.2 2.6 20-22.3 20 22.3 20-22.3 20 22.3 20-22.3 20 22.3 20-22.3 20 22.3 1.5-1.6V82.7a82.38 82.38 0 00-81-82.7zm-21.8 79.9a7.5 7.5 0 11-7.5 7.5 7.5 7.5 0 017.5-7.5zm42.8 0a7.5 7.5 0 11-7.5 7.5 7.5 7.5 0 017.5-7.5z"
        />
        <ellipse
          cx="128.45"
          cy="248.2"
          fill={content({ theme }, "tertiary")}
          rx="66.8"
          ry="7.8"
        />
      </svg>
      <Message isPage={isPage} size={size}>
        <SafeHTML html={message} />
      </Message>
    </Root>
  );
};

export default UiKitEmpty;
